var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'mobile' : _vm.isMobile},attrs:{"id":"wrapper"}},[_c('div-header',{attrs:{"logged":_vm.logged}}),_c('div',{class:{'login_class' : _vm.logged},attrs:{"id":"content"}},[_c('router-view')],1),_c('div-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }